export default __webpack_public_path__ + "static/media/gallery-wip-emitter_06.0baf0287.jpg";